import {WorkPlanItemDTOExtended} from "../../../models/WorkPlanItem";
import DayOverviewHeader from "./day-overview/day-overview-header/DayOverviewHeader";
import DayOverViewTask from "./day-overview/day-overview-task/DayOverViewTask";
import {store} from "../../../stateManagement/store";
import {setSelectedTaskId} from "../../../stateManagement/reducers/workPlanViewReducer";

interface Props {
    unfinishedTasks: WorkPlanItemDTOExtended[];
    fetchTasks: () => void;
}

const handleOnSelectTask = (taskId: number | undefined) => {
    store.dispatch(setSelectedTaskId(taskId));
};

export const UnfinishedTasks = (props: Props) => {
    if(props.unfinishedTasks.length === 0) {
        return null;
    }
    return (
        <>
            <DayOverviewHeader
                expanded={true}
                bookings={[]}
                handleOnClick={() => {}}
                tasks={props.unfinishedTasks}
                isCalendar={false}
                isUnfinished={true}
            />
            
            {props.unfinishedTasks.map(t => {
                return (
                    <DayOverViewTask
                        key={t.workTaskId}
                        task={t}
                        fetchTasks={props.fetchTasks}
                        isCalendar={false}
                        isUnfinished={true}
                        enableActions={true}
                        handleSelect={handleOnSelectTask}
                    />
                )
            })}
        </>
    )
}